import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { setQuestions } from "../../stories/actions";
import { getAreasModel, getStationModel, getTaskModel, getQuestionModel, getIsRoomExists } from "../../services/api";
import { isEmpty, removeHtmlTags } from "../../utilities/methods";
import { toast } from "react-toastify";
import * as rooRTC from "../../services/roomRTC";

import Label from "../Labels/Label";

import "./Room.css";

const StationSingle = ({ roomId, descricao, station, taskCard, areaCard,
    questionCard, setQuestionsAction, isTimeStamp }) => {
    const notify = (message) => {
        toast(message);
    };

    const handlerOpenTask = async () => {
        const roomResponse = await getIsRoomExists(roomId);
        const { roomExists, full } = roomResponse;

        if (isTimeStamp) {
            notify("O timer ainda está em execução. Por favor, aguarde mais alguns instantes.");
        } else if (!roomExists || !full) {
            notify("Aguarde o ator para o treinamento...");
        } else {
            const task = taskCard.find((t) => t.estacaoId === station.id);

            if (task) {
                const area = areaCard.find((a) => a.id === station.areaId);
                const questions = questionCard.filter((q) => q.cardId === station.id);

                rooRTC.sendTaskDataChannel(task.id, area.areaId, task.estacaoId, task.cenario, task.descricao, task.tarefas,
                    task.ativo, task.pdf, task.video, task.orientacoes, task.localAtuacao, area.descricao, roomId);

                setQuestionsAction(questions);
            }
        }
    };

    const text = removeHtmlTags(descricao);

    return (text) && (
        <div className="task_single_container" onClick={handlerOpenTask}>
            <span className="material-symbols-outlined icon_task_single">keep</span>
            <span className="name_task_single">{text}</span>
        </div>
    );
};

const Stations = ({ isRoomHost, roomId, isTimeStamp, setQuestionsAction }) => {
    const [param, setParam] = useState("");
    const [stationSearch, setStationSearch] = useState([]);
    const [isSearch, setIsSearch] = useState(false);
    const [areaCard, setAreaCard] = useState([]);
    const [stations, setStations] = useState([]);
    const [taskCard, setTaskCard] = useState([]);
    const [questionCard, setQuestionCard] = useState([]);

    const handlerChangeTask = (e) => {
        var value = e.target.value;
        setParam(value.toLowerCase());
    };

    const handlerKeyPress = (e) => {
        if (e.key === "Enter") {
            handlerButtonPress();
            setParam("");
        }
    };

    const handlerButtonPress = () => {
        if (!isEmpty(param)) {
            const namePart = param.split(" ");

            const model = stations.filter(data => {
                const nomeLower = data.descricao.toLowerCase();
                return namePart.every(part => nomeLower.includes(part));
            });

            setStationSearch([]);
            setIsSearch(true);

            if (model) {
                setStationSearch(model);
            } else {
                console.log("Usuário não encontrado");
            }
        }
    };

    const handlerCleanSearch = () => {
        setIsSearch(false);
    };

    const runningOfAreasModel = async () => {
        await getAreasModel(setAreaCard);
    };

    const runningOfStationsModel = async () => {
        await getStationModel(setStations);
    };

    const runningOfTasksModel = async () => {
        await getTaskModel(setTaskCard);
    };

    const runningOfQuestionsModel = async () => {
        await getQuestionModel(setQuestionCard);
    };

    useEffect(() => {
        runningOfAreasModel();

        runningOfStationsModel();

        runningOfTasksModel();

        runningOfQuestionsModel();
    }, []);

    return (isRoomHost) && (
        <div className='row tasks_container'>
            <Label text="ESTAÇÕES" />

            <div className="col-md-12 mb-2">
                <div className='input_group_container'>
                    <input
                        type='text'
                        value={param}
                        placeholder='Pesquisar...'
                        onChange={handlerChangeTask}
                        onKeyDown={handlerKeyPress}
                        className='form-control input_theme_style' />

                    <span className="material-symbols-outlined btn_icon_circle"
                        title={isSearch ? "Limpar esta pesquisa" : "Pesquisar tarefa"}
                        onClick={isSearch ? handlerCleanSearch : handlerButtonPress}> {isSearch ? "mop" : "search"} </span>
                </div>
            </div>

            {isSearch ? <div className="col-md-12 mb-2 tasks_list tasks_overlay_container">
                {stationSearch.filter((station, index, self) => index === self.findIndex((u) => (
                    u.descricao === station.descricao
                ))).map((station, index) => (
                    <StationSingle
                        key={`${station.descricao}-${index}`}
                        roomId={roomId}
                        descricao={station.descricao}
                        station={station}
                        taskCard={taskCard}
                        areaCard={areaCard}
                        questionCard={questionCard}
                        setQuestionsAction={setQuestionsAction}
                        isTimeStamp={isTimeStamp}
                    />
                ))}
            </div> :
                <div className="col-md-12 mb-2 tasks_list tasks_overlay_container">
                    {stations.filter((station, index, self) => index === self.findIndex((u) => (
                        u.descricao === station.descricao
                    ))).map((station, index) => (
                        <StationSingle
                            key={`${station.descricao}-${index}`}
                            roomId={roomId}
                            descricao={station.descricao}
                            station={station}
                            taskCard={taskCard}
                            areaCard={areaCard}
                            questionCard={questionCard}
                            setQuestionsAction={setQuestionsAction}
                            isTimeStamp={isTimeStamp}
                        />
                    ))}
                </div>}
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapStateActionToProps = (dispatch) => {
    return {
        setQuestionsAction: (questions) => dispatch(setQuestions(questions)),
    };
};

export default connect(mapStoreToProps, mapStateActionToProps)(Stations);